"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CardColor = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _heading = _interopRequireWildcard(require("../heading"));

var _index = _interopRequireDefault(require("./index.scss"));

// Card
// ====
var CardColor;
exports.CardColor = CardColor;

(function (CardColor) {
  CardColor["white"] = "white";
  CardColor["none"] = "none";
})(CardColor || (exports.CardColor = CardColor = {}));

var CardHeader = function CardHeader(_ref) {
  var title = _ref.title,
      heading = _ref.heading,
      headingProps = _ref.headingProps,
      headerElement = _ref.headerElement,
      headerUnderline = _ref.headerUnderline;

  var headerElements = _react["default"].createElement(_react["default"].Fragment, null, title && _react["default"].createElement("div", {
    className: _index["default"].title
  }, title), heading && _react["default"].createElement(_heading["default"], (0, _extends2["default"])({
    type: _heading.HeadingSize.large
  }, headingProps), heading), headerElement && _react["default"].createElement("div", null, headerElement));

  return headerUnderline ? _react["default"].createElement("div", {
    className: (0, _classnames["default"])((0, _defineProperty2["default"])({}, _index["default"].headerUnderlined, headerUnderline))
  }, headerElements) : headerElements;
};

var Card = function Card(_ref2) {
  var _cx2;

  var title = _ref2.title,
      heading = _ref2.heading,
      headingProps = _ref2.headingProps,
      className = _ref2.className,
      children = _ref2.children,
      headerElement = _ref2.headerElement,
      _ref2$cardColor = _ref2.cardColor,
      cardColor = _ref2$cardColor === void 0 ? CardColor.white : _ref2$cardColor,
      _ref2$headerUnderline = _ref2.headerUnderline,
      headerUnderline = _ref2$headerUnderline === void 0 ? false : _ref2$headerUnderline,
      _ref2$cardPadding = _ref2.cardPadding,
      cardPadding = _ref2$cardPadding === void 0 ? true : _ref2$cardPadding;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, (_cx2 = {}, (0, _defineProperty2["default"])(_cx2, _index["default"].cardWhite, cardColor === CardColor.white), (0, _defineProperty2["default"])(_cx2, _index["default"].cardPadding, cardPadding), _cx2))
  }, _react["default"].createElement(CardHeader, {
    title: title,
    heading: heading,
    headingProps: headingProps,
    headerElement: headerElement,
    headerUnderline: headerUnderline
  }), _react["default"].createElement("div", {
    className: _index["default"].childrenWrapper
  }, children));
};

var _default = Card;
exports["default"] = _default;